import { useState, useEffect, useCallback } from "react";
import apiFetch from "../../../../shared/services/apiClient";

/**
 * Carga el resumen agregado de CxC por filial desde el backend.
 * El servidor hace GROUP BY + SUM en la base de datos; el frontend
 * solo recibe una fila por filial (no todos los registros CxC).
 *
 * fechaInicio / fechaFinal: filtran facturadoPeriodo y abonadoPeriodo.
 * El saldo acumulado (totalSaldo) es siempre all-time.
 */
export function useCxcFiliales(filtro, search, refreshKey, fechaInicio, fechaFinal) {
  const [filas, setFilas] = useState([]);
  const [todasFilas, setTodasFilas] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      let url = "/api/finance/cuentaXCobrar/dashboard-summary/";
      if (fechaInicio && fechaFinal) {
        url += `?fecha_inicio=${fechaInicio}&fecha_final=${fechaFinal}`;
      }
      const res  = await apiFetch(url);
      const data = await res.json();
      // data ya viene como [{filialId, filialLabel, propietario, totalMonto, totalAbono, totalSaldo, cantFacturas}]
      const todas = Array.isArray(data) ? data : [];

      // Ordenar naturalmente por idFilial (base para todo)
      todas.sort((a, b) =>
        a.filialLabel.localeCompare(b.filialLabel, undefined, { numeric: true, sensitivity: "base" })
      );
      setTodasFilas(todas);

      // Aplicar filtro de estado
      let lista = todas;
      if (filtro === "debiendo") {
        lista = lista.filter((r) => r.totalSaldo > 0);
      } else if (filtro === "aldia") {
        lista = lista.filter((r) => r.totalSaldo <= 0);
      }

      // Aplicar búsqueda
      if (search.trim()) {
        const q = search.trim().toLowerCase();
        lista = lista.filter(
          (r) =>
            r.filialLabel.toLowerCase().includes(q) ||
            r.propietario.toLowerCase().includes(q),
        );
      }

      setFilas(lista);
    } catch (e) {
      console.error("Error cargando resumen CxC:", e);
    } finally {
      setLoading(false);
    }
    // refreshKey fuerza la recarga aunque no se use en el cuerpo
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtro, search, refreshKey, fechaInicio, fechaFinal]);

  useEffect(() => {
    load();
  }, [load]);

  return { filas, todasFilas, loading, refetch: load };
}
